export const generalMapping = (omekaData: any) => {
  const locationCategories = omekaData?.['locations:CategoriesLvl2']?.map((item: any) => item?.['display_title']).concat(omekaData?.['locations:CategoriesLvl3']?.map((item: any) => item?.['display_title'])).join(', ') || '-';
  const locationCategoriesL1 = omekaData?.['locations:locationsCategory']?.map((item: any) => item?.['display_title']).join(', ') || '-';
  const locationOwners = omekaData?.['locations:type_of_owner']?.map((item: any) => item?.['@value']) || '-';
  const locationAvailablePeople = `${omekaData?.['locations:locationOwnerName']?.map((item: any) => item?.['@value']) || ''} ${omekaData?.['locations:locationOwnerSurname']?.map((item: any) => item?.['@value']) || '-'}`;
  const locationPhone = omekaData?.['locations:locationOwnerTel']?.map((item: any) => item?.['@value']) || '-';
  const locationEmail = omekaData?.['locations:locationOwnerEmail']?.map((item: any) => item?.['@value']) || '-';
  const locationWebsite = omekaData?.['locations:ownerWebsite']?.map((item: any) => item?.['@value']) || '-';
  const locationFilmOffice = omekaData?.['locations:Film Offices']?.map((item: any) => item?.['display_title']) || '-';
  const locationAccessSpecialNeeds = omekaData?.['locations:accesibilityForPeopleWithSpecialNeeds']?.map((item: any) => item?.['@value'])[0] || '-';
  const locationAccessToHeavyVehicles = omekaData?.['locations:accessToHeavyVehicles']?.map((item: any) => item?.['@value'])[0] || '-';
  const locationPlaceRestrictions = omekaData?.['locations:restrictions']?.map((item: any) => item?.['@value'])[0] || '-';
  const locationKeywords = omekaData['locations:locationsKeyWords']?.map((item: any) => item?.['@value'])[0].split(',');
  const description = omekaData?.['dcterms:description']?.map((item: any) => item?.['@value']);
  const region = omekaData?.['locations:region']?.map((item: any) => item?.['@value']) || '-';
  const title = omekaData?.['dcterms:title']?.map((item: any) => item?.['@value']) || '-';
  const postal_code = omekaData?.['locations:postal_code']?.map((item: any) => item?.['@value']) || '-';
  const address = `${omekaData?.['locations:street']?.map((item: any) => item?.['@value'])} ${omekaData?.['locations:street_number']?.map((item: any) => item?.['@value']) || ''}`;
  const licenseInformation = omekaData?.['locations:licenseInformation']?.map((item: any) => item?.['@value'])[0] || '-';
  const licenseInfoExternal = omekaData?.['locations:licenseInfoExternal']?.map((item: any) => item?.['@value']) || '-';
  const licenseInformation_en = omekaData?.['locations:licenseInformation_en']?.map((item: any) => item?.['@value'])[0] || '-';
  const locationKeywords_gr = omekaData?.['locations:locationsKeyWords_gr']?.map((item: any) => item?.['@value'])[0].split(',');
  const description_en = omekaData?.['locations:description_en']?.map((item: any) => item?.['@value']);
  const restrictions_en = omekaData?.['locations:restrictions_en']?.map((item: any) => item?.['@value'])[0] || '-';

  const locationRelativeProfessionals = omekaData['locations:Professionals']?.map((item: any) => {
    return {
      name: { url: `/professionals/details/${item?.['o:id']}`, label: `${item?.['professionals:professionalName']?.map((item: any) => item?.['@value']) || ''} ${item?.['professionals:professionalSurname']?.map((item: any) => item?.['@value']) || '-'}` },
      value: [item?.['o:title'], '']
    };
  });

  const locationRelativeMovies = omekaData['locations:Movies']?.map((item: any) => {
    return {
      name: { url: `/search-documents/details/${item?.['o:id']}`, label: item?.['o:title'] },
      value: [item?.['documents:documentsType']?.map((item: any) => item?.['@value']) || '-', item?.['documents:documentsDateCreation']?.map((item: any) => item?.['@value']) || '-']
    };
  });

  const locationRelativeProject = omekaData?.['@reverse']?.['projects:projectRelationWithLocation']?.map((item: any) => {
    return {
      name: {
        url: `/search-projects/details/${item?.['@id'].split('/').at(-1)}`,
        label: item?.['o:title']
      },
      value: ['', '']
    };
  });

  // maybe this function should be somewhere else :)
  let locationScope;
  if (locationOwners) {
    locationScope = locationOwners[0] === 'admin'
      ? 'Δημόσιος'
      : 'Ιδιωτικός';
  }
  const profTitle = omekaData?.['professionals:businessName']?.map((item: any) => item?.['@value']) || omekaData?.['professionals:professionalName']?.map((item: any) => item?.['@value']) + omekaData?.['professionals:professionalSurnmae']?.map((item: any) => item?.['@value']);
  const businessName = omekaData?.['professionals:businessName']?.map((item: any) => item?.['@value']) || '-';
  const professionalName = omekaData?.['professionals:professionalName']?.map((item: any) => item?.['@value']) || '-';
  const professionalSurname = omekaData?.['professionals:professionalSurname']?.map((item: any) => item?.['@value']) || '-';
  const professionalPhone = omekaData?.['professionals:professionalTelNumber']?.map((item: any) => item?.['@value']) || '-';
  const professionalDescription = omekaData?.['dcterms:description']?.map((item: any) => item?.['@value']) || '-';
  const professionalEmail = omekaData?.['professionals:professionalEmail']?.map((item: any) => item?.['@value']) || '-';
  const professionalWebsite = omekaData?.['professionals:professionalWebsite']?.map((item: any) => item?.['@value']) || '-';
  const professionalFacebook = omekaData?.['professionals:professionalFacebook']?.map((item: any) => item?.['@value']) || '-';
  const professionalInstagram = omekaData?.['professionals:professionalInstagram']?.map((item: any) => item?.['@value']) || '-';
  const professionalLinkedIn = omekaData?.['professionals:professionalLinkedin']?.map((item: any) => item?.['@value']) || '-';
  const professionalYoutube = omekaData?.['professionals:professionalYoutube']?.map((item: any) => item?.['@value']) || '-';
  const professionalTwitter = omekaData?.['professionals:professionalTwitter']?.map((item: any) => item?.['@value']) || '-';
  const professionalVimeo = omekaData?.['professionals:professionalVimeo']?.map((item: any) => item?.['@value']) || '-';
  const serviceAreas = omekaData?.['professionals:serviceAreas']?.map((item: any) => item?.['@value']) || '-';
  const servicesCategory = omekaData?.['professionals:servicesCategory']?.map((item: any) => item?.['@value']) || '-';
  const professionalSpecialty = omekaData?.['professionals:professionalSpecialtyLvl2']?.map((item: any) => item?.['display_title']).join(', ') || '-';
  const communicationLanguages = omekaData?.['professionals:communicationLanguages']?.map((item: any) => item?.['@value']) || '-';
  const vatCode = omekaData?.['professionals:vatCode']?.map((item: any) => item?.['@value']) || '-';
  const professionalAddress = (omekaData?.['professionals:professionalStreetName']?.map((item: any) => item?.['@value']) || '') + ' ' + (omekaData?.['professionals:professionalStreetNumber']?.map((item: any) => item?.['@value']) || '-');
  const professionalTk = omekaData?.['professionals:professionalPostCode']?.map((item: any) => item?.['@value']) || '-';
  const professionalsProd = omekaData?.['foaf:pastProject']?.map((item: any) => item?.['@value']) || '-';
  const professionalServicesEn = omekaData?.['professionals:professionalServicesEn']?.map((item: any) => item?.['@value']) || '-';
  const professionalProductionsEn = omekaData?.['professionals:professionalProductionEn']?.map((item: any) => item?.['@value']) || '-';

  return {
    professionalServicesEn,
    professionalProductionsEn,
    locationCategories,
    locationCategoriesL1,
    locationOwners,
    locationAvailablePeople,
    locationPhone,
    locationEmail,
    locationWebsite,
    description,
    locationFilmOffice,
    locationAccessSpecialNeeds,
    locationAccessToHeavyVehicles,
    locationPlaceRestrictions,
    locationRelativeMovies,
    locationRelativeProject,
    locationRelativeProfessionals,
    locationKeywords,
    licenseInformation_en,
    locationKeywords_gr,
    description_en,
    restrictions_en,
    region,
    postal_code,
    title,
    address,
    locationScope,
    profTitle,
    businessName,
    professionalName,
    professionalSurname,
    professionalPhone,
    professionalDescription,
    professionalEmail,
    professionalWebsite,
    professionalFacebook,
    professionalInstagram,
    professionalLinkedIn,
    professionalYoutube,
    professionalTwitter,
    professionalVimeo,
    serviceAreas,
    servicesCategory,
    professionalSpecialty,
    communicationLanguages,
    vatCode,
    professionalAddress,
    professionalTk,
    professionalsProd,
    ...(locationOwners === 'visitor'
      ? {
        licenseInformation: licenseInformation
      }
      : {
        licenseInformation: licenseInfoExternal
      })
  };
};

export const greekToEnglishLetters: any = {
  'α': 'a',
  'ά': 'a',
  'β': 'b',
  'γ': 'g',
  'δ': 'd',
  'ε': 'e',
  'έ': 'e',
  'ζ': 'z',
  'η': 'i',
  'ή': 'i',
  'θ': 'th',
  'ι': 'i',
  'ί': 'i',
  'κ': 'k',
  'λ': 'l',
  'μ': 'm',
  'ν': 'n',
  'ξ': 'x',
  'ο': 'o',
  'ό': 'o',
  'π': 'p',
  'ρ': 'r',
  'σ': 's',
  'ς': 's',
  'τ': 't',
  'υ': 'y',
  'ύ': 'y',
  'φ': 'f',
  'χ': 'ch',
  'ψ': 'ps',
  'ω': 'o',
  'ώ': 'o',
  'Α': 'A',
  'Ά': 'A',
  'Β': 'B',
  'Γ': 'G',
  'Δ': 'D',
  'Ε': 'E',
  'Έ': 'E',
  'Ζ': 'Z',
  'Η': 'I',
  'Ή': 'I',
  'Θ': 'TH',
  'Ι': 'I',
  'Ί': 'I',
  'Κ': 'K',
  'Λ': 'L',
  'Μ': 'M',
  'Ν': 'N',
  'Ξ': 'X',
  'Ο': 'O',
  'Ό': 'O',
  'Π': 'P',
  'Ρ': 'R',
  'Σ': 'S',
  'Τ': 'T',
  'Υ': 'Y',
  'Ύ': 'Y',
  'Φ': 'F',
  'Χ': 'X',
  'Ψ': 'PS',
  'Ω': 'O',
  'Ώ': 'O',
};